import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { LOGOUT } from '../../actions/auth';
import { PAGE_URL } from '../../../utils/constants';
import { push } from 'connected-react-router';

export default action$ => action$.pipe(
  ofType(LOGOUT),
  map(() => push(PAGE_URL.HOME))
);